"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _InputConstants = require("./InputConstants");

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _FieldsetContext = require("../context/FieldsetContext");

var TYPES = ['text', 'email', 'number', 'password', 'search', 'url'];

var UITextInput = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UITextInput, _PureComponent);

  function UITextInput() {
    (0, _classCallCheck2.default)(this, UITextInput);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITextInput).apply(this, arguments));
  }

  (0, _createClass2.default)(UITextInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          error = _this$props.error,
          inputRef = _this$props.inputRef,
          placeholder = _this$props.placeholder,
          styled = _this$props.styled,
          use = _this$props.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "error", "inputRef", "placeholder", "styled", "use"]);
      var fieldSize = this.context.size;
      return _react.default.createElement("input", Object.assign({}, rest, {
        className: (0, _classnames.default)('form-control private-form__control', _InputConstants.INPUT_SIZE_OPTIONS[fieldSize], className, {
          'private-form__control--unstyled uiTextInputUnstyled': !styled,
          'private-form__control--error': error
        }, _InputConstants.USE_CLASSES[use]),
        placeholder: (0, _lazyEval.default)(placeholder),
        ref: inputRef
      }));
    }
  }]);
  return UITextInput;
}(_react.PureComponent);

UITextInput.contextType = _FieldsetContext.FieldsetContext;
UITextInput.propTypes = {
  defaultValue: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.bool,
  inputRef: _refObject.default,
  onChange: _propTypes.default.func,
  placeholder: (0, _createLazyPropType.default)(_propTypes.default.string),
  readOnly: _propTypes.default.bool,
  styled: _propTypes.default.bool.isRequired,
  type: _propTypes.default.oneOf(TYPES),
  use: _propTypes.default.oneOf(Object.keys(_InputConstants.USE_CLASSES)),
  value: _propTypes.default.string
};
UITextInput.defaultProps = {
  error: false,
  styled: true,
  type: 'text'
};
UITextInput.displayName = 'UITextInput';

var _default = (0, _ShareInput.default)(UITextInput);

exports.default = _default;
module.exports = exports.default;